import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import theme from '../../theme';
import { CMxComponents } from '@codametrix/ui-components/src/types';
import { ColDef } from '@codametrix/grid';
import React, { useState } from 'react';
import { DataGrid } from '../../components/data-grid/data-grid';
import {
  EndpointData,
  HTTPMethodType
} from '../../components/data-grid/data-grid-utils';
import { SubHeader } from '../organizations/subheader';
import { gridOptions } from '../users/user-list-utils';
import { styles } from './external-app-users/external-app.styles';

const endpoint = (orgId: number) => {
  const params = [['organizationId', `${orgId}`]];
  const endPoint: EndpointData = {
    endPoint: `/externalApplication/list/v1`,
    HTTPMethodType: HTTPMethodType.GET,
    params: params
  };
  return endPoint;
};

export const updatedColDefs = (columnDefs: CMxComponents.ColumnDefintion[]) => {
  const cols: ColDef[] = columnDefs.map(
    (col: CMxComponents.ColumnDefintion, index: number) => {
      let column: ColDef = {
        ...col,
        headerName: col.displayName,
        field: col.key,
        sortable: false
      };
      // Primary column matches tenants/users: interactive accent for row-click navigation.
      if (index === 0) {
        column.cellStyle = { color: theme.colors.accent[200] };
      }
      return column;
    }
  );
  return cols;
};

export const ExternalApplicationList: React.FC<AppProps.ExternalApplicationListProps> = props => {
  const { onSelection, orgId, columnDefs, sortablePageable } = props;
  const classes = styles();
  const [pageSize, setPageSize] = useState<number>(25);

  const handleSelect = (rowData: any) => {
    onSelection(rowData.data, window.location.pathname);
  };

  const onPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);
  };

  return (
    <AdminListPageLayout>
      <SubHeader
        title={'External applications'}
        className={classes.text}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
      />
      <Box
        paddingTop={theme.space[16]}
        flex="1 1 0"
        minHeight={0}
        display="flex"
        flexDirection="column">
        <DataGrid
          serverSideInfiniteScroll
          columnDefs={updatedColDefs(columnDefs)}
          gridOptions={gridOptions}
          filterableOptions={sortablePageable.filterableOptions}
          endpointData={endpoint(orgId)}
          onRowClicked={item => {
            handleSelect(item);
          }}
          paginationPageSize={pageSize}
        />
      </Box>
    </AdminListPageLayout>
  );
};
